//signal
export const CONNECT = 'CONNECT';
export const DISCONNECT = 'DISCONNECT';
export const CONNECT_ACK = 'CONNECT_ACK';
export const PUBLISH = 'PUBLISH';
export const PUB_ACK = 'PUB_ACK';
//subsignal
export const FRP = 'FRP';
export const FP = 'FP';
export const UPUI = 'UPUI';
export const GPGI = 'GPGI';
export const GPGM = 'GPGM';
export const GAM = 'GAM';
export const GC = 'GC';
export const GMI = 'GMI';
export const GKM = 'GKM';
export const GQ = 'GQ';
export const GD = 'GD';
export const MP = 'MP';
export const MS = "MS";
export const MN = "MN";
export const MR = "MR";
export const RMN = "RMN";
export const GQNUT = "GQNUT";
export const GMURL = "GMURL";
export const US = "US";
export const FAR =  "FAR";
export const FRN = "FRN";
export const FHR = "FHR";
export const FN = "FN";
export const MMI = "MMI";


export const KEY_DEVICE_ID = 'key_device_id';
export const KEY_USER_ID = 'key_user_id'; 
export const KEY_TOKEN = 'key_token';
export const LAST_MESSAGE_SEQ = "key_last_message_seq";
export const SEND_MESSAGE_COUNT = "key_send_message_count";
export const FRIEND_REQUEST_VERSION = "key_friend_request_version";
export const SEND_MESSAGE_ID = "key_send_message_id";
export const USER_INFO_LIST = "key_user_infos_list";
export const USER_MESSAGES = "key_user_messages";
export const USER_CONVERSATIONS = "key_user_coversations";

export const DEFACULT_VUE_IMG = "../../assets/img/uimg/u__qun-vue.png";


export const ERROR_CODE = 400;
export const SUCCESS_CODE = 200;



// WEBPACK FOOTER //
// ./src/fscommon/constant/system.js